import { context, propagation } from "@opentelemetry/api";
import axios, { AxiosError } from "axios";
import { createSessionAuthError, useSessionManager } from "~/composables/useSessionManager";

const instance = axios.create({
	headers: {
		'Accept': '*/*'
	},
	baseURL: "https://192.168.217.35:3336",
	// baseURL: "http://0.tcp.ngrok.io:16406",
	// httpsAgent: new https.Agent({
	//   rejectUnauthorized: false, // (NOTE: this will disable client verification)
	//   cert: fs.readFileSync("../SSL/ismael.r3sist.com.br-crt.pem"),
	//   key: fs.readFileSync("../SSL/ismael.r3sist.com.br-key.pem"),
	// }),
	// httpsAgent,
});

instance.interceptors.request.use((config) => {
	const currentContext = context.active();
	const carrier = { ...(config.headers || {}) } as Record<string, string>;
	propagation.inject(currentContext, carrier);
	config.headers = carrier;
	return config;
});

instance.interceptors.response.use(
	(response) => {
		return response;
	},
	async (error) => {
		const sessionManager = useSessionManager();
		if (error.response?.status === 401) {
			await sessionManager.handleAuthFailure("unauthorized", undefined, 401);
		}

		const normalizedError = new AxiosError(
			error.response?.data?.response ?? error.message,
			error.code,
			error.config,
			error.request,
			error.response,
		);

		return Promise.reject(Object.assign(normalizedError, {
			status: error.response?.status,
			response: error.response,
			code: error.response?.status === 401 ? createSessionAuthError("unauthorized").code : error.code,
		}));
	}
);

// const r3ApiClientAxios = new r3ApiClient("axios").create();
// r3ApiClientAxios.setUrl("http://192.168.1.240:3335");

export default defineNuxtPlugin(() => {
	return {
		provide: {
			axios: instance,
		},
	};
});
